<template>
  <toast-component />
  <header-component v-if="!isHeaderVisible" />
  <router-view />
</template>

<script setup>
import { ref, watch } from "vue";
import HeaderComponent from "@/components/common/HeaderComponent.vue";
import router from "@/plugins/router";

const currentRoute = router.currentRoute;
const isHeaderVisible = ref(
  currentRoute.value.path === "/" || currentRoute.value.path === "/integration"
);

watch(currentRoute, () => {
  isHeaderVisible.value =
    currentRoute.value.path === "/" ||
    currentRoute.value.path === "/integration";
});
</script>

<style scoped>
@import "@/assets/main.css";
</style>
